import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import 'lib-flexible/flexible'
import './assets/iconfont/iconfont.css'
import comJs from './assets/js/conmon'
Vue.use(comJs)

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint);  

import 'vant/lib/index.css';
import Vant from 'vant'
Vue.use(Vant)

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import NutUI from '@nutui/nutui';
import '@nutui/nutui/dist/nutui.css';
NutUI.install(Vue);
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)


import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

//定义全局时间过滤器
import moment from 'moment'
Vue.prototype.$moment = moment;//赋值使用
moment.locale('zh-cn');//需要汉化
Vue.filter("timeFormat", (timeData, patten = "YY-MM-DD HH:mm:ss") => {
  return moment(timeData).format(patten)
})

Vue.config.productionTip = false
import '@/assets/css/common.css';

Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})



// WEBPACK FOOTER //
// ./src/main.js